/**
 * Uses MUI's default `md` breakpoint (900px). The app's theme.tsx does not
 * define custom breakpoints, so `theme.breakpoints.down("md")` matches
 * screens narrower than 900px.
 */
import { useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"

export default function useIsMobile(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down("md"))
}
